import { store } from "../../../../../config/store";
import { openCloseToast } from "../../../../Global/actions";
import trace from "../../../../../helpers/trace";
import moment from "moment";
import {getAllCentrosAPI, getHolidayAdministrative, createHolidayAdministrative, updateHolidayAdministrative, deleteHolidayAdministrative} from '../../../../../services/mantenedoresSelApi';

export const loadingCentros = (isLoading) => ({
  type: "LOADING_CENTROS",
  isLoading,
});

export const loading = (isLoading) => ({
  type: "LOADING_FERIADOS_SCHEDULER",
  isLoading,
});

export const openCloseModalEditarScheduler = (isOpen, appointment, isNew) => ({
  type: "OPEN_CLOSE_MODAL_EDITAR_SCHEDULER",
  isOpen,
  appointment,
  isNew,
});

export const openCloseModalEliminarAppointment = (isOpen, appointment) => ({
  type: "OPEN_CLOSE_MODAL_ELIMINAR_APPOINTMENT",
  isOpen,
  appointment,
});

export const setAppointment = (data) => ({
  type: "SET_APPOINTMENT",
  data,
});

export const setAppointmentList = (list) => ({
  type: "SET_APPOINTMENT_LIST",
  list,
});

export const setCentros = (data) => ({
  type: "SET_APPOINTMENT_CENTROS",
  data,
});

export const doGetCentros = () => async (dispatch) => {
  dispatch(loadingCentros(true));
  const request = await getAllCentrosAPI();
  if (request.status === 200) {
    let data = await request.json();
    dispatch(setCentros(data));
  }
  dispatch(loadingCentros(false));
}

export const doGetAppointments = (start, end) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await getHolidayAdministrative(start, end);

    if (request.status === 200) {
      let data = await request.json();
      let dataMap = [];
      data.forEach((hollyDay) => {
        let centers = [];
        hollyDay.Centers.forEach((center) => {
          centers.push(center.Id);
        });

        dataMap.push({
          allDay: hollyDay.AllDay,
          centers: centers,
          endDate: hollyDay.EndDate,
          id: hollyDay.Id,
          repeat: hollyDay.Repeat,
          repeatEndDate: hollyDay.RepeatEndDate,
          repeatOnOff: hollyDay.RepeatOnOff,
          startDate: hollyDay.StartDate,
          text: hollyDay.Description
        });
      });
      dispatch(setAppointmentList(dataMap));
    }
  } catch (error) {
    trace("doGetAppointments", error);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente mas tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doAddAppointment = (appointment) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let centers = [];
    appointment.centers.forEach((center) => {
      centers.push({
        Id: center,
        Code: "",
        Description: ""
      })
    });

    let data = {
      Description: appointment.text,
		  AllDay: appointment.allDay,
		  StartDate: appointment.startDate,
		  EndDate: appointment.endDate,
		  RepeatOnOff: appointment.repeatOnOff,
		  Repeat: appointment.repeat,
	    RepeatEndDate: appointment.repeatEndDate,
		  Centers: centers
    }

    const request = await createHolidayAdministrative(data);

    if (request.status === 200) {
      data = await request.json();
      const { listaAppointments, defaultTotalCupos } = store.getState().mantenedorFeriados;
      const newApp = buildRecurrence(appointment);
      const newList = [...listaAppointments];
      if (newList[newApp.id] == null && newList.length < defaultTotalCupos) {
        newList.push(newApp);
      } else {
        newList[newList.length - 1] = newApp;
      }
      dispatch(setAppointmentList(addEmptyAppointments(newList, defaultTotalCupos)));
      dispatch(setAppointmentList(newList));
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: `${appointment.text} creado con exito!`,
        typeStyle: "success",
        displayTime: 5000
      }));
      dispatch(openCloseModalEditarScheduler(false, {}, false));
    }else{
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión al guardar",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    console.error(e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión al guardar",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doUpdateAppointment = (appointment) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let centers = [];
    appointment.centers.forEach((center) => {
      centers.push({
        Id: center,
        Code: "",
        Description: ""
      })
    });

    var isBefore = moment(appointment.startDate).isSameOrBefore(appointment.endDate);

    if(!isBefore){
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: `No puede ingresar una fecha de fin menor a la fecha de inicio`,
        typeStyle: "error",
        displayTime: 5000
      }));
      dispatch(loading(false));
      return;
    }

    let data = {
      Id: appointment.id,
      Description: appointment.text,
      AllDay: appointment.allDay,
      StartDate: appointment.startDate,
      EndDate: appointment.endDate,
      RepeatOnOff: appointment.repeatOnOff,
      Repeat: appointment.repeat,
      RepeatEndDate: appointment.repeatEndDate,
      Centers: centers
    }

    const request = await updateHolidayAdministrative(data);

    if (request.status === 200) {
      const { listaAppointments } = store.getState().mantenedorFeriados;
      const editedList = [...listaAppointments];
      const newApp = buildRecurrence(appointment);
      const index = editedList.findIndex((item) => item.id === appointment.id);
      if (index !== -1) {
        editedList[index] = newApp;
      } else {
        editedList.push(newApp);
      }
      dispatch(setAppointmentList(editedList));
      dispatch(openCloseModalEditarScheduler(false, {}, false));
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: `${appointment.text} editado!`,
        typeStyle: "success",
        displayTime: 5000
      }));
    }else{
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión al guardar",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    console.error(e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión al guardar",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doDeleteAppointment = (appointment) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await deleteHolidayAdministrative(appointment.id);
    if (request.status === 200) {
      const { listaAppointments } = store.getState().mantenedorFeriados;
      const updatedList = [...listaAppointments].filter((item) => item.id !== appointment.id);
      dispatch(setAppointmentList([...updatedList]));
      dispatch(openCloseModalEliminarAppointment(false, {}));
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: `${appointment.text} eliminado con exito!`,
        typeStyle: "success",
        displayTime: 5000
      }));
    }
  } catch (e) {
    console.error(e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión al eliminar",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const buildRecurrence = (appointment) => {
  const newApp = { ...appointment };
  if (appointment.repeatOnOff) {
    const day = new Date(newApp.startDate).getDate();
    const weekDay = getDayForRecurrence(new Date(newApp.startDate));
    const month = new Date(newApp.startDate).getMonth() + 1;
    let endDate = new Date(newApp.repeatEndDate).toJSON();
    endDate = endDate.replace(/([-:.])/g, "");
    switch (appointment.repeat) {
      case "0": {
        newApp.recurrenceRule = `FREQ=${newApp.repeat};BYDAY=${weekDay};UNTIL=${endDate}`;
        break;
      }
      case "1": {
        newApp.recurrenceRule = `FREQ=${newApp.repeat};BYMONTHDAY=${day};UNTIL=${endDate}`;
        break;
      }
      case "2": {
        newApp.recurrenceRule = `FREQ=${newApp.repeat};UNTIL=${endDate};BYMONTHDAY=${day};BYMONTH=${month}`;
        break;
      }
      default: {
        break;
      }
    }
  }
  return newApp;
};

export const getDayForRecurrence = (date) => [
  "SU",
  "MO",
  "TU",
  "WE",
  "TH",
  "FR",
  "SA",
][date.getDay()];

const getAppointmentsInTheSameTime = (lista = [], appointment = {}, length = false) => {
  const sameTime = lista.filter((i) => new Date(i.startDate).getTime() === new Date(appointment.startDate).getTime());
  if (length) return sameTime.length;
  return sameTime;
};

const getEmptyAppointmentsSpaces = (appointments = [], appointment = {}, limit) => {
  const list = [];
  const appInTheSameHour = getAppointmentsInTheSameTime(appointments, appointment, true);
  for (let i = appInTheSameHour; i < limit; i++) {
    list.push({
      id: appointments.length + i, startDate: appointment.startDate, endDate: appointment.endDate, disabled: true
    });
  }
  return list;
};

export const addEmptyAppointments = (appointmentsList, total) => {
  if (!appointmentsList) return [];
  let newList = [...appointmentsList];
  appointmentsList.forEach((i) => {
    const emptySpaces = getEmptyAppointmentsSpaces(newList, i, total);
    newList = [...newList, ...emptySpaces];
  });
  return newList;
};
